// Lib
import React from "react";
import { withFormik } from "formik";
import * as yup from "yup";

// Components
import Signup from "./SignupForm";

// Actions
import userSignup from "./ApiService";

// Form Constructor
const validationSchema = yup.object().shape({
  email: yup.string().email("E-mail inválido").required("E-mail é obrigatório"),

  person_type: yup.string().required("Tipo de cadastro é obrigatório"),

  name: yup.string().required("Nome é obrigatório"),

  cpf: yup.string().required("CPF é obrigatório"),

  date_of_birth: yup.string().required("Data de Nascimento é obrigatório"),

  phone: yup.string().required("Telefone é obrigatório"),

  address: yup.string().required("obrigatório"),

  address_number: yup.string().required("obrigatório"),

  address_neighborhood: yup.string().required("obrigatório"),

  address_zipcode: yup.string().required("obrigatório"),

  address_city_name: yup.string().required("obrigatório"),

  address_state_code: yup.string().required("obrigatório"),

  password: yup
    .string()
    .required("Senha obrigatória")
    .min(8, "Digite pelo menos 8 caracteres"),

  terms_of_use: yup
    .bool()
    .oneOf(
      [true],
      "Para prosseguir, você precisa aceitar os termos de uso e de consentimento"
    ),

  broker_manager: yup.string(),
});

const broker_manager = () => {
  const qs = new URLSearchParams(document.location.search);
  return qs.get("referral") || "";
};

const SignupForm = withFormik({
  displayName: "SignupForm",
  validationSchema,
  validateOnBlur: false,
  validateOnChange: false,
  mapPropsToValues: () => ({
    person_type: "person",
    company_tax_regime: "",
    company_responsible_name: "",
    email: "",
    date_of_birth: "",
    cpf: "",
    phone: "",
    name: "",
    password: "",
    address: "",
    address_number: "",
    address_neighborhood: "",
    address_zipcode: "",
    address_complement: "",
    address_city_name: "",
    address_state_code: "",
    broker_manager: broker_manager(),
    have_history_apuration: "Não, este é meu primeiro mês",
    terms_of_use: false,
  }),
  handleSubmit: (values, { props, setErrors, setSubmitting }) => {
    setSubmitting(true);

    props
      .userSignupHandler(values)
      .then(() => {
        window.location.href = "/criar-conta?account_created=true";
      })
      .catch((errors) => {
        setErrors(errors);
        setSubmitting(false);
      });
  },
})(Signup);

const UserSignupContainer = (props) => (
  <SignupForm userSignupHandler={userSignup} />
);

UserSignupContainer.propTypes = {};

export default UserSignupContainer;
